<template>
  <div>
    <div v-if="pageLoading" class="text-center" style="padding: 80px 0;">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Carregando...</span>
      </div>
      <p class="mt-2">Carregando...</p>
    </div>
    <div class="main-content" v-else>
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Movimentação</div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="col-md-12">
              <div class="form-row">
                <div class="form-group col-md-3">
                  <label>Modelo:</label>
                  <p class="preview-text">{{ movement.product && movement.product.product_model ? movement.product.product_model.name : "-" }}</p>
                </div>
                <div class="form-group col-md-3">
                  <label>Patrimônio:</label>
                  <p class="preview-text">{{ movement.product ? (movement.product.barcode || "-") : "-" }}</p>
                </div>
                <div class="form-group col-md-3">
                  <label>Fabricante:</label>
                  <p class="preview-text">{{ movement.product && movement.product.manufacturer ? movement.product.manufacturer.name : "-" }}</p>
                </div>
                <div class="form-group col-md-3">
                  <label>Fornecedor:</label>
                  <p class="preview-text">{{ movement.product && movement.product.supplier ? movement.product.supplier.name : "-" }}</p>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-3">
                  <label>Origem:</label>
                  <p class="preview-text">{{ originLabel(movement) }}</p>
                </div>
                <div class="form-group col-md-3">
                  <label>Destino:</label>
                  <p class="preview-text">{{ destinationLabel(movement) }}</p>
                </div>
                <div class="form-group col-md-3">
                  <label>Novo Status:</label>
                  <p class="preview-text">
                    <span v-if="movement.new_status !== null && movement.new_status !== undefined" class="soft-badge" :class="statusBadgeClass(movement.new_status)">
                      {{ statusLabel(movement.new_status) }}
                    </span>
                    <span v-else class="text-muted">Manteve status atual</span>
                  </p>
                </div>
                <div class="form-group col-md-3">
                  <label>Movimentado Por:</label>
                  <p class="preview-text">{{ movement.user ? movement.user.name : "?" }}</p>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-3">
                  <label>Data:</label>
                  <p class="preview-text">{{ formatDate(movement.moved_at) }}</p>
                </div>
                <div class="form-group col-md-9">
                  <label>Observação:</label>
                  <p class="preview-text">{{ movement.notes || "-" }}</p>
                </div>
              </div>

              <div class="block text-right mb-1">
                <router-link to="/stock_movements" class="btn btn-back">
                  <i class="fa fa-arrow-left"></i> Voltar
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Histórico de Movimentações desse Produto</div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="table-responsive">
              <table class="table table-striped table-bordered crud-table">
                <thead>
                  <tr>
                    <th>Origem</th>
                    <th>Destino</th>
                    <th>Movimentado Por</th>
                    <th>Data</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!history.length">
                    <td colspan="5" class="text-center py-4">Nenhuma movimentação encontrada</td>
                  </tr>
                  <tr v-for="h in history" :key="h.id">
                    <td data-label="Origem">{{ originLabel(h) }}</td>
                    <td data-label="Destino">{{ destinationLabel(h) }}</td>
                    <td data-label="Movimentado Por">{{ h.user ? h.user.name : "?" }}</td>
                    <td data-label="Data">{{ formatDate(h.moved_at) }}</td>
                    <td data-label="Status" class="text-center">
                      <span v-if="h.new_status !== null && h.new_status !== undefined" class="soft-badge" :class="statusBadgeClass(h.new_status)">
                        {{ statusLabel(h.new_status) }}
                      </span>
                      <span v-else class="text-muted">Manteve status atual</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "stockMovementView",
  data() {
    return {
      pageLoading: true,
      movement: {},
      history: [],
    };
  },
  methods: {
    originLabel(item) {
      if (!item.from_unit && !item.from_client) return "Sem origem";
      const client = item.from_client ? item.from_client.company_name : "?";
      const unit = item.from_unit ? item.from_unit.name : "?";
      return client + " / " + unit;
    },

    destinationLabel(item) {
      const client = item.to_client ? item.to_client.company_name : "?";
      const unit = item.to_unit ? item.to_unit.name : "?";
      return client + " / " + unit;
    },

    formatDate(value) {
      if (!value) return "-";
      return value.substring(0, 10).split("-").reverse().join("/");
    },

    statusLabel(status) {
      const labels = { 1: "Em estoque", 2: "Em uso", 3: "Manutenção", 0: "Baixado" };
      return labels[status] ?? "Baixado";
    },

    statusBadgeClass(status) {
      const classes = {
        1: "badge-success",
        2: "badge-primary",
        3: "badge-warning",
        0: "badge-danger",
      };
      return classes[status] ?? "badge-secondary";
    },

    getMovement: function (id) {
      const self = this;
      return axios
        .get(
          self.$store.state.api +
            "stock_movements/" +
            id +
            "?with[]=product&with[]=product.productModel&with[]=product.manufacturer&with[]=product.supplier&with[]=fromClient&with[]=fromUnit&with[]=toClient&with[]=toUnit&with[]=user"
        )
        .then((response) => {
          self.movement = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getHistory: function (productId) {
      const self = this;
      if (!productId) return;

      return axios
        .get(
          self.$store.state.api +
            "stock_movements?product_id=" +
            productId +
            "&paginated=false&with[]=fromClient&with[]=fromUnit&with[]=toClient&with[]=toUnit&with[]=user&orderByDesc=moved_at"
        )
        .then((response) => {
          self.history = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  async mounted() {
    const self = this;
    const id = self.$route.params.id;

    self.pageLoading = true;

    try {
      await self.getMovement(id);
      await self.getHistory(self.movement.product_id);
    } catch (e) {
      console.error(e);
    } finally {
      self.pageLoading = false;
    }
  },
};
</script>
<style scoped>
.preview-text {
  margin-bottom: 0;
}

.crud-table {
  margin-bottom: 0;
  font-size: 0.95rem;
  width: 100%;
}

.crud-table td,
.crud-table th {
  padding: 0.9rem 0.75rem;
  white-space: normal;
  overflow-wrap: break-word;
}

.crud-table thead th {
  background-color: #283046 !important;
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
  vertical-align: middle;
  border-left: none !important;
  border-right: none !important;
  font-size: 0.80rem;
}

.crud-table tbody tr,
.crud-table tbody tr:nth-of-type(odd),
.crud-table tbody tr:nth-of-type(even) {
  background-color: #132133 !important;
}

.crud-table tbody td {
  background-color: #132133 !important;
}

.soft-badge {
  display: inline-block;
  white-space: normal;
  padding: 0.5em 0.75em;
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1.2;
  border-radius: 6px;
  border: 1px solid transparent;
}

.soft-badge.badge-danger {
  background-color: rgba(234, 84, 85, 0.12) !important;
  border-color: rgba(234, 84, 85, 0.4);
  color: #d97577 !important;
}

.soft-badge.badge-warning {
  background-color: rgba(255, 159, 67, 0.12) !important;
  border-color: rgba(255, 159, 67, 0.4);
  color: #d99a5c !important;
}

.soft-badge.badge-success {
  background-color: rgba(40, 199, 111, 0.12) !important;
  border-color: rgba(40, 199, 111, 0.4);
  color: #5cb98a !important;
}

.soft-badge.badge-primary {
  background-color: rgba(115, 103, 240, 0.12) !important;
  border-color: rgba(115, 103, 240, 0.4);
  color: #8b82df !important;
}

.soft-badge.badge-secondary {
  background-color: rgba(130, 134, 139, 0.12) !important;
  border-color: rgba(130, 134, 139, 0.4);
  color: #a9adb3 !important;
}

body:not(.dark-layout) .crud-table thead th {
  background-color: rgba(255, 255, 255, 0.45) !important;
}

body:not(.dark-layout) .crud-table tbody tr,
body:not(.dark-layout) .crud-table tbody tr:nth-of-type(odd),
body:not(.dark-layout) .crud-table tbody tr:nth-of-type(even),
body:not(.dark-layout) .crud-table tbody td {
  background-color: rgba(255, 255, 255, 0.35) !important;
}

body:not(.dark-layout) .soft-badge.badge-danger { color: #ea5455 !important; }
body:not(.dark-layout) .soft-badge.badge-warning { color: #ff9f43 !important; }
body:not(.dark-layout) .soft-badge.badge-success { color: #28c76f !important; }
body:not(.dark-layout) .soft-badge.badge-primary { color: #7367f0 !important; }
body:not(.dark-layout) .soft-badge.badge-secondary { color: #82868b !important; }

@media (max-width: 768px) {
  .crud-table thead { display: none; }
  .crud-table, .crud-table tbody, .crud-table tr, .crud-table td {
    display: block;
    width: 100% !important;
  }
  .crud-table tr {
    margin-bottom: 14px;
    border-radius: 8px;
    padding: 14px;
    border: 1px solid rgba(255,255,255,.08);
  }
  .crud-table td[data-label]::before {
    content: attr(data-label);
    display: block;
    font-size: 10.5px;
    font-weight: 700;
    letter-spacing: .3px;
    text-transform: uppercase;
    color: rgba(255,255,255,.45);
    margin-bottom: 4px;
  }
  .crud-table td[data-label] {
    text-align: left !important;
  }
  body:not(.dark-layout) .crud-table td[data-label]::before {
    color: rgba(0,0,0,.45);
  }
}
</style>
